const images = [
  {
    thumb: require("../../../assets/collection/champions/dab_flamma.jpg"),
    src: require("../../../assets/collection/champions/dab_flamma.jpg"),
    caption: "Dąb Flamma",
    srcset: require("../../../assets/collection/champions/dab_flamma.jpg"),
    description: ""
  },
  {
    thumb: require("../../../assets/collection/champions/dab_secretariat.jpg"),
    src: require("../../../assets/collection/champions/dab_secretariat.jpg"),
    caption: "Dąb Secretariat",
    srcset: require("../../../assets/collection/champions/dab_secretariat.jpg"),
    description: ""
  }
];

export default images;
